import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import util from 'utils/utils';

class ProfileChip extends Component {
  clicked = (e) => {
    if (this.props.onClick) {
      e.preventDefault();
      this.props.onClick();
    }
  };

  render() {
    const {
      profile, as, style, colour, precedingText, disableLink,
    } = this.props;
    if (!profile) return null;
    return (
      <div style={{ ...style, display: 'flex', alignItems: 'center' }} onClick={this.clicked}>
        <span as={as || Link} to={!disableLink ? `/profiles/${profile._id}` : '#'} style={{
          backgroundImage: `url(${util.profileLogo(profile)})`, marginRight: '5px', display: 'inline-block', verticalAlign: 'middle', width: 30, height: 30, minWidth: 30, minHeight: 30, lineHeight: 'inherit', backgroundSize: 'cover', backgroundPosition: 'center center',
        }} />
        <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          <Link to={!disableLink ? `/profiles/${profile._id}` : '#'} className='with-border' style={{ marginBottom: 0, color: colour || 'inherit' }}>{' '}{precedingText}{profile.name}</Link>
        </div>
      </div>
    );
  }
}

export default ProfileChip;
